import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";
import { handleError } from "../../../services/ErrorHandle";

export const updateCurrencyApi = createAsyncThunk(
  "currancy/update",
  async (data) => {

    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/user/cucurrency/updateCurrancy/${data.id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData}`,
          "Content-Type": "application/json",
        },
        body:JSON.stringify({
          currency : data.currency
        }),
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        return result;
      })
      .catch((error) => {
        return error;
      });

    return request;
  }
);

const updateCurrencySlicer = createSlice({
  name: "currancy",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateCurrencyApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCurrencyApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        handleError(state.error);
        LogoutFunction();
      } else if (action.payload.message === "Updated Successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload;
        handleError(state.error);
      }
    });
    builder.addCase(updateCurrencyApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      handleError(state.error);
    });
  },
});

export default updateCurrencySlicer.reducer;
